module.exports = __webpack_public_path__ + "img/1553650688.af0d608c.jpg";